import { render, staticRenderFns } from "./NewProjectsBudgetStatus.vue?vue&type=template&id=6a6e7ff0"
import script from "./NewProjectsBudgetStatus.vue?vue&type=script&lang=js"
export * from "./NewProjectsBudgetStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports